import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    transformHttpResponse,
} from 'utils';
import { ATTENDANCE_SAVE_SUCCESS } from './saveAction';

/**
 * Create (no id) or update (existing id) one athlete's National Team
 * classification — mirrors saveAttendance exactly, but for the SEPARATE
 * `isNationalTeamMember` axis (never a CompetitionAttendanceStatus value,
 * see api/docs/ATTENDANCE.md). Dispatches the SAME ATTENDANCE_SAVE_SUCCESS
 * action saveAttendance does: listReducer's case upserts by result.id
 * regardless of which field changed, so no new reducer case is needed —
 * this stays a single Redux slice, edited from either axis.
 *
 * PATCHing only `isNationalTeamMember` (or POSTing without `status`) never
 * touches attendance status server-side — the two fields are independently
 * diffed by AttendanceService::recordChange.
 */
export const saveNationalTeamMember = ({ competitionId, sportsmanId, existingId = null, isNationalTeamMember }) => {
    return function(dispatch) {
        const options = existingId
            ? apiRequestOptions(apiPath.ATTENDANCE.PATCH, { isNationalTeamMember }, { params: { id: existingId } })
            : apiRequestOptions(apiPath.ATTENDANCE.POST, {
                competition: '/api/competitions/' + competitionId,
                sportsman: '/api/sportsmen/' + sportsmanId,
                isNationalTeamMember,
            });

        return axios(options)
            .then(transformHttpResponse)
            .then(response => {
                dispatch({ type: ATTENDANCE_SAVE_SUCCESS, result: response.data, competitionId });
                return response.data;
            })
            .catch(rejectWithViolationMessage);
    }
};

const rejectWithViolationMessage = error => {
    const violations = error.response && error.response.data && error.response.data.violations;
    const message = (violations && violations.length && violations[0].message)
        || (error.response && error.response.data && error.response.data['hydra:description'])
        || (error.response && error.response.data && error.response.data.message)
        || 'Save failed';
    return Promise.reject(new Error(message));
};
